import Swal from 'sweetalert2';
import { escapeHtml } from '@/helpers/string';
import { track } from '@/modules/Flexigo/helpers/rum';

function calculateToastTimer(title, text) {
  const combined = `${title || ''} ${text || ''}`.trim();
  if (!combined) return 3000;
  const wordCount = combined.split(/\s+/).length;
  // Base 3s plus ~400ms per word, capped at 10s so very long messages don't linger forever.
  return Math.min(10000, 3000 + wordCount * 400);
}

export default {
  name: 'toaster',
  methods: {
    async getToaster(icon, title, text = '', timer = null) {
      // Datadog RUM: which component's operation succeeded or failed. Never the message, which
      // is translated and can contain names.
      track(`toast:${icon}:${this?.$options?.name || 'unknown'}`);
      const displayTimer = timer ?? calculateToastTimer(title, text);
      let backgroundColor = '';
      switch (icon) {
        case 'success':
          backgroundColor = '#f4fbf6';
          break;
        case 'error':
          backgroundColor = '#fcf5f6';
          break;
        case 'warning':
          backgroundColor = '#fefbf6';
          break;
        case 'info':
          backgroundColor = '#f6f7ff';
          break;
        default:
      }

      // Determine if we need the large toast class
      const isLargeToast = displayTimer >= 6000;

      const escapedTitle = escapeHtml(title);
      const escapedText = escapeHtml(text);
      const htmlContent = escapedText ? `<b>${escapedTitle}</b><br>${escapedText}` : `<b>${escapedTitle}</b>`;

      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        showCloseButton: true,
        background: backgroundColor,
        timer: displayTimer,
        timerProgressBar: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
          backdrop: 'swal2-backdrop-hide',
        },
        customClass: {
          content: 'content-class',
          container: 'container-class',
          title: 'title-class',
          popup: isLargeToast ? 'popup-class toast-large' : 'popup-class', // Add toast-large for long timeouts
          icon: 'icon-class',
          header: 'header-class',
        },
      });
      Toast.fire({
        icon,
        title: htmlContent,
      });
    },

    // Convenience wrapper for the very common "log + show error toaster"
    // pattern around failed API calls. Extracts the most informative message
    // available from an axios-style error and falls back to a generic title.
    notifyApiError(error, fallbackText = '') {
      // eslint-disable-next-line no-console
      console.error(error);
      const message = error?.response?.data?.error?.message || error?.message || fallbackText;
      this.getToaster('error', this.$t('flexigo.common.error'), message);
    },
  },
};
